export default __webpack_public_path__ + "static/events-light-c83822b8c480e6f5fe358f90bdbbf08c.png";